'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscussionEmbed = exports.CommentEmbed = exports.CommentCount = undefined;

var _CommentCount = require('./CommentCount');

var _CommentEmbed = require('./CommentEmbed');

var _DiscussionEmbed = require('./DiscussionEmbed');

exports.CommentCount = _CommentCount.CommentCount;
exports.CommentEmbed = _CommentEmbed.CommentEmbed;
exports.DiscussionEmbed = _DiscussionEmbed.DiscussionEmbed;


var Disqus = {
    CommentCount: _CommentCount.CommentCount,
    CommentEmbed: _CommentEmbed.CommentEmbed,
    DiscussionEmbed: _DiscussionEmbed.DiscussionEmbed
};

exports.default = Disqus;


//////////////////
// WEBPACK FOOTER
// ./~/disqus-react/lib/index.js
// module id = 362
// module chunks = 107818501498521